import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMagnifyingGlass = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.9251 12.5988L13.6543 12.9472L13.9663 13.2592L17.3536 16.6464C17.5488 16.8417 17.5488 17.1583 17.3536 17.3536C17.1583 17.5488 16.8417 17.5488 16.6464 17.3536L13.2592 13.9663L12.9472 13.6543L12.5988 13.9251C11.3287 14.9124 9.7337 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8C15.5 9.7337 14.9124 11.3287 13.9251 12.5988ZM8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 4.41015 11.5899 1.5 8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5Z",
		fill: "#444444",
		stroke: "#444444"
	})
});
export default SvgMagnifyingGlass;
